import { PossibleQuestion } from '../interfaces/surveyScreen';

export const questionMap = (question: PossibleQuestion): PossibleQuestion => {
  const layoutType = question.type;
  switch (layoutType) {
    case 'QU':
      return {
        type: question.type,
        itemId: question.itemId,
        scaleId: question.scaleId,
        hasNoEvidence: question.hasNoEvidence ? question.hasNoEvidence : false,
        labels: [],
        questionDescription: '',
        title: question.title,
        competency: question.competency,
        questionText: question.questionText,
        selectedResponse: question.selectedResponse ? question.selectedResponse : '',
      };
    case 'IR':
      return {
        type: question.type,
        itemId: question.itemId,
        scaleId: question.scaleId || null,
        hasNoEvidence: question.hasNoEvidence ? question.hasNoEvidence : false,
        labels: [],
        questionDescription: question.competencyDescription,
        title: question.questionText,
        questionText: question.competencyName,
        selectedResponse: question.selectedResponse ? question.selectedResponse : '',
      };
    case 'MC':
      return question;
    case 'OQ':
      return question;
    default:
      return {};
  }
};

export const filterAnswered = (
  questions: PossibleQuestion[],
): {
  QU: PossibleQuestion[];
  IR: PossibleQuestion[];
  AD: PossibleQuestion[];
} => {
  const QU: PossibleQuestion[] = [];
  const IR: PossibleQuestion[] = [];
  const AD: PossibleQuestion[] = [];
  questions.forEach((question: PossibleQuestion) => {
    if (question.selectedResponse !== null) {
      switch (question.type) {
        case 'QU':
          QU.push(question);
          break;
        case 'IR':
          IR.push(question);
          break;
        case 'MC':
          AD.push(question);
          break;
        case 'OQ':
          AD.push(question);
          break;
        default:
          break;
      }
    }
  });
  return { QU, IR, AD };
};

export const allQuestions = (
  questions: PossibleQuestion[],
): {
  QU: PossibleQuestion[];
  IR: PossibleQuestion[];
  AD: PossibleQuestion[];
} => {
  const QU: PossibleQuestion[] = [];
  const IR: PossibleQuestion[] = [];
  const AD: PossibleQuestion[] = [];
  questions.forEach((question: PossibleQuestion) => {
    switch (question.type) {
      case 'QU':
        QU.push(question);
        break;
      case 'IR':
        IR.push(question);
        break;
      case 'MC':
        AD.push(question);
        break;
      case 'OQ':
        AD.push(question);
        break;
      default:
        break;
    }
  });
  return { QU, IR, AD };
};
